const PinSvg = (props: any) => {
  if (props.outlined) {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.4372 2.24805L29.7519 13.5627L27.8652 15.448L26.9226 14.5054L21.2666 20.1614L20.3239 24.876L18.4372 26.7614L12.7812 21.104L6.18123 27.704L4.2959 25.8187L10.8959 19.2187L5.23857 13.5627L7.1239 11.676L11.8399 10.7334L17.4959 5.07738L16.5532 4.13471L18.4386 2.24805H18.4372ZM19.3812 6.96271L13.1532 13.1894L9.39057 13.9427L18.0572 22.6094L18.8092 18.8467L25.0372 12.62L19.3812 6.96271Z"
          fill="white"
        />
      </svg>
    )
  }
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.7519 13.5627L27.8652 15.448L26.9226 14.5054L21.2666 20.1614L20.3239 24.876L18.4372 26.7614L12.7812 21.104L6.18123 27.704L4.2959 25.8187L10.8959 19.2187L5.23857 13.5627L7.1239 11.676L11.8399 10.7334L17.4959 5.07738L16.5532 4.13471L18.4386 2.24805L29.7519 13.5627Z"
        fill="#2F80ED"
      />
    </svg>
  )
}

export default PinSvg
